<template>
  <div ref="replaceViaLink" aria-hidden="true" class="modal fade" id="replace-via-link" role="dialog" style="display: none">
    <div class="modal-dialog">
      <div class="modal-content">

        <div class="modal-header">
          <h5 class="modal-title mt-0">
            {{ $t('upload_new_version_link.title') }}
          </h5>
          <button aria-label="Close" class="close" data-dismiss="modal" type="button">
            <span aria-hidden="true">x</span>
          </button>
        </div>

        <div class="modal-body">
          <transition-expand>
            <version-options-form :userVersionOptions="$props.userVersionOptions" :replace-now="false" @version-options-callback="versionOptionsFormCallback" v-show='!versionRequest' />
          </transition-expand>
          <div class="form-group">
            <label>
              <input type='checkbox' :value='record.skip_automatic_version_change' v-model='record.skip_automatic_version_change' name="version_request[skip_automatic_version_change]"/>
              {{ $t('request_new_version.skip_auto_replace') }}
            </label>
          </div>
          <div class="form-group">
            <div v-if='versionRequest' class='copy-to-clipboard-wrapper'>
              <label>
                {{ $t('upload_new_version_link.share_this_link') }}
              </label>
              <input type='text' disabled='disabled' :value='versionRequestPath' class='form-control input-link-to-clipboard' />
              <p>
                {{ $t('upload_new_version_link.hint') }}
              </p>
              <button class='btn btn-outline-primary float-right' @click.prevent="copyToClipboard($event, '.input-link-to-clipboard')">
                {{ $t('upload_new_version_link.copy_link') }}
              </button>
            </div>
            <div class="no-version-link text-center" v-else>
              <label>
                {{ $t('upload_new_version_link.get_link') }}
              </label>
              <br/>
              <a href='#' @click.prevent='createVersionRequest' class="btn btn-primary">
                {{ $t('upload_new_version_link.request_new_version') }}
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import _version_options_form from '../components/records/_version_options_form'
  import TransitionExpand from '../components/shared/transition_expand'

  export default {
    components: {
      'version-options-form': _version_options_form,
      'transition-expand': TransitionExpand
    },
    props: {
      record: {
        required: true,
        default: () => { return {} }
      },
      userVersionOptions: {
        required: true,
        type: Array,
        default: () => { return [] }
      }
    },
    data() {
      return {
        versionRequest: null,
        versionOptions: [],
        versionOptionsSave: true,
        versionOptionsDoNothing: false
      }
    },
    created() {
      this.loadVersionOptions()
    },
    computed: {
      versionRequestPath() {
        return window.location.origin + this.$router.resolve({ name: 'public_version_request', params: { uuid: this.versionRequest.uuid } }).href
      }
    },
    methods: {
      openModal() {
        this.loadVersionOptions()
        $(this.$refs.replaceViaLink).modal('show')
      },
      createVersionRequest() {
        let params = {
          version_request: {
            show_old: true,
            skip_automatic_version_change: this.$props.record.skip_automatic_version_change
          }
        }

        this.store.createVersionRequest(this.$props.record.id, params).then(({data}) => {
          if(this.versionOptionsSave)
            this.store.updateUserProfile({ user: { version_options: this.versionOptions } })

          this.store.sendMetrics({name: 'upload_new_version_via_link', params: this.$route.params, path: this.$route.fullPath})
          this.versionRequest = data
        })
      },
      loadVersionOptions(){
        this.store.getCurrentUser().then((data) => {
          this.versionOptions = data.user.version_options || []
        })
      },
      versionOptionsFormCallback(options, save, doNothing){
       this.versionOptions = options
       this.versionOptionsSave = save
       this.versionOptionsDoNothing = doNothing
      }
    }
  }
</script>
<style lang="sass" scoped>
.no-version-link
  padding-top: 10px
</style>
